import _extends from "@babel/runtime/helpers/extends";
import { theme } from "@vitality-ds/system";
export default (function (baseStyles) {
  return _extends({}, baseStyles, {
    alignItems: "center",
    justifyContent: "center",
    gap: "".concat(theme.space.sm)
  });
});